export default [
  {
    path: '/report/wageComparison',
    name: '工资对比表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/report/wageComparison.vue`),
    meta: {
      permission: ['hr_wage_new_report_gzdb']
    }
  },
  {
    path: '/report/annualWage',
    name: '成本中心对比表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/report/annualWage.vue`),
    meta: {
      permission: ['hr_wage_new_report_cbzxdb']
    }
  },
  {
    path: '/report/averageWage',
    name: '年度平均工资明细表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/report/averageWage/averageWage.vue`),
    meta: {
      permission: ['hr_wage_new_report_ndpjgz']
    }
  },
  // {
  //   path: '/wage/empWagesDetailColumnsList',
  //   name: '员工工资明细报表',
  //   component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/empWagesDetailColumnsList.vue`),
  //   meta: {
  //     permission: ['empWagesDetailColumnsList']
  //   }
  // },
  {
    path: '/wage/costCenterSummaryColumnsList',
    name: '成本中心汇总报表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/costCenterSummary.vue`),
    meta: {
      permission: ['hr_wage_new_report_cbzx']
    }
  },
  {
    path: '/wage/wageComparisonColumnsList',
    name: '工资对比报表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/wageComparisonColumnsList.vue`),
    meta: {
      permission: ['wage_salary_yop']
    }
  },
  {
    path: '/wage/averageWageColumnsList',
    name: '年度工资汇总报表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/averageWageColumnsList.vue`),
    meta: {
      permission: ['wage_salary_yop']
    }
  },
  {
    path: '/report/annualAverageWage',
    name: '年度平均工资报表',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/averageWage/annualAverage.vue`),
    meta: {
      permission: ['hr_wage_new_report_ndpjgz']
    }
  },
  // {
  //   path: '/wage/costAccountingColumnsList',
  //   name: '成本核算报表',
  //   component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/costAccountingColumnsList.vue`),
  //   meta: {
  //     permission: ['hr_org_manage']
  //   }
  // },

  // {
  //   path: '/wage/taxRateSummaryList',
  //   name: '税率汇总报表',
  //   component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/taxRateSummaryList.vue`),
  //   meta: {
  //     permission: ['wage_salary_yop']
  //   }
  // },
  {
    path: '/report/payReport',
    name: '雇员发薪明细',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/wage/report/payReport.vue`),
    meta: {
      permission: ['hr_wage_new_report_xzmx']
    }
  },
  {
    path: '/report/ReportCli',
    name: '自定义报表',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/wage/report/Report.vue`),
    meta: {
      permission: ['hr_wage_new_report_zdybb']
    }
  },
  {
    path: '/audit_forward_xsyrzxq',
    name: '薪税云日志详情',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['audit_forward_xsyrzxq']
    }
  },
  {
    path: '/audit_forward_xsyrfwtj',
    name: '薪税云日访问统计',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['audit_forward_xsyrfwtj']
    }
  },
  {
    path: '/audit_forward_xcyrzxq',
    name: '薪酬云日志详情',
    component: () => import ( `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['audit_forward_xcyrzxq']
    }
  }
]
